// extracted by mini-css-extract-plugin
export default {"todoItem":"EditTodo_todoItem__4IZLs","todoItemContainer":"EditTodo_todoItemContainer__qBSEI","actionMobileContainer":"EditTodo_actionMobileContainer__2SvcY"};